import React, { useEffect } from "react";
import styled from "@emotion/styled";

import {
  Grid,
  List,
  ListItemText as MuiListItemText,
  ListItemButton as MuiListItemButton,
} from "@mui/material";
import AddNewClient from "../pages/meus-clientes/add";
import { useLocation } from "react-router";
import FooterBar from "../layouts/FooterBar";
import { Box } from "react-feather";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(0.25)}
    ${(props) => props.theme.spacing(4)};
  background: ${(props) => props.theme.footer.background};
  position: relative;
`;

const ListItemButton = styled(MuiListItemButton)`
  display: inline-block;
  width: auto;
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};

  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`;

function Footer() {
  let location=window.location.href;

  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    setSelectedValue();
  };
  
  
  if(String(location).includes("#addNewClient")){
 
    window.history.replaceState(null, null, window.location.pathname)
    handleClickOpen();
  }

  return (


    <Wrapper>
       { !window.isNativeApp && 
      <Grid container spacing={0}>
        <Grid
          sx={{ display: { xs: "none", md: "block" } }}
          container
          item
          xs={12}
          md={6}
        >
          <List>
            <ListItemButton component="a" href="contato@maximalhost.com">
              <ListItemText primary="Suporte" />
            </ListItemButton>
            <ListItemButton component="a" href="https://www.cachebank.com.br/contratos/politica-privacidade/atualizado.pdf">
              <ListItemText primary="Privacidade" />
            </ListItemButton>
            <ListItemButton component="a" href="https://www.cachebank.com.br/contratos/termo-de-uso/atualizado.pdf">
              <ListItemText primary="Termos de Uso" />
            </ListItemButton>
          </List>
        </Grid>
        <Grid container item xs={12} md={6} justifyContent="flex-end">
          <List>
            <ListItemButton>
              <ListItemText primary={`© ${new Date().getFullYear()} - Cachê Bank`} />
            </ListItemButton>
          </List>
        </Grid>
      </Grid>
}
      
      { window.isNativeApp &&    
      
      <React.Fragment>
        
        <Grid style={{marginTop:100}}></Grid>
        <FooterBar />
      </React.Fragment>
      
 }



      <AddNewClient
            selectedValue={selectedValue}
            open={open}
            onClose={handleClose}
            key={open}
          />

    </Wrapper>
  );
}

export default Footer;
